import store from "@/store";

// Custom Provident Fund label (falls back to "Provident Fund"); fallback lives in the system/pfLabel getter.
// Reactive when read inside a computed/template, so it also works outside components (e.g. salarySlipTemplateData.js).
export const getPfLabel = () => store.getters["system/pfLabel"];
